<a
  panButton
  class="float-right"
  icon="edit"
  color="info"
  [routerLink]="['/home', 'manage', 'branch', params.branchId(), 'location', params.data.id]"
></a>
